import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as _ from "lodash";
import { ToastrService } from 'ngx-toastr';
import { Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserDetailsService } from 'src/app/service/user-details.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Title } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import {saveAs} from 'file-saver';
import { base64StringToBlob } from 'blob-util';
import { AppService } from 'src/app/service/app.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent {

}
